import React from "react";
import SavChatMessages from "../../SavChatMessages";

const UpdateTicketSAVEchanges = ({
  activeTab,
  notificationCount,
  scrollableComment,
  setScrollableComment,
}) => {
  switch (activeTab) {
    case "Comments":
      return (
        <SavChatMessages
          scrollableComment={scrollableComment}
          notificationCount={notificationCount}
          setScrollableComment={setScrollableComment}
        />
      );

    case "Admin notes":
      return (
        <SavChatMessages
          scrollableComment={scrollableComment}
          isAdmin
          notificationCount={notificationCount}
          setScrollableComment={setScrollableComment}
        />
      );

    default:
      <SavChatMessages notificationCount={notificationCount} />;
  }
};

export default UpdateTicketSAVEchanges;
